import { Geolocation } from '../../common/types'

export interface CustomMarker {
  exactLocation: boolean
  geolocation: Geolocation
  lat: number
  lon: number
  id: number
  price: number
}

export interface ClusterMarker {
  center: Geolocation
  count: number
  rect: Array<Geolocation>
  size: number
  urlRect: string
}

export enum MoveDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right'
}
